<div class="img-gallery-container">
  <swiper [config]="swiperConfig" class="custom-swiper-class" #swiper>
    <ng-template swiperSlide *ngFor="let image of images">
      <img class="img" mat-card-image [src]="image.url" alt="Photo of an item"
        onerror="this.src='https://placehold.co/500x250?text=corpers.ng&font=roboto'; this.onerror=null;" />
    </ng-template>
  </swiper>

  <button *ngIf="images.length > 1" #prevBtn type="button" [ngClass]="['prev-button-' + uniqueClass]" mat-icon-button color="primary"
    aria-label="Previous image" class="move-button" (click)="swipePrev()" >
    <mat-icon>chevron_left</mat-icon>
  </button>

  <button *ngIf="images.length > 1" #nextBtn type="button" [ngClass]="['next-button-' + uniqueClass]" mat-icon-button color="primary"
    aria-label="Next image" class="right-btn move-button"
    (click)="swipeNext()"
    >
    <mat-icon>chevron_right</mat-icon>
  </button>

</div>

<!-- 
  sample here https://stackblitz.com/edit/swiper-angular-example?file=src%2Fapp%2Fapp.component.html
  also check https://www.positronx.io/angular-swiper-image-touch-slider-example-tutorial/
-->